import { Assignment } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core";
import styles from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Button from "components/CustomButtons/Button.js";
import DeleteIcon from "@material-ui/icons/Delete";
import VisibilityIcon from "@material-ui/icons/Visibility";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import CardBody from "components/Card/CardBody";
import CustomInput from "components/CustomInput/CustomInput";
import ReactTable from "react-table";
import { travelApi } from "functions/apis";
import { token } from "functions/Helper";

const useStyles = makeStyles(styles);

const MerchantInventoryControlGroupList = () => {
  const classes = useStyles();

  const [filter, setFilter] = useState({
    searchString: ""
  });
  const [pagination, setPagination] = useState({
    pageIndex: 1,
    pageSize: 10
  });
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pages, setPages] = useState(0);

  const merchantInventoryControlGroupListSignal = React.useRef(
    new AbortController()
  );

  useEffect(() => {
    return () => {
      merchantInventoryControlGroupListSignal.current.abort();
    };
  }, []);

  useEffect(() => {
    setLoading(true);
    travelApi
      .get("inventoryControlGroups", {
        params: {
          filter,
          pagination
        },
        signal: merchantInventoryControlGroupListSignal.current.signal
      })
      .then(resp => {
        setData(
          resp.records.map(record => {
            return {
              ...record,
              actions: (
                <div className="actions-right">
                  {(token["travelagent.inventory_control_groups.read"] ===
                    "allowed" ||
                    token.is_admin === "True") && (
                    <Link
                      to={
                        "/admin/MerchantInventoryControlGroup/View/" + record.id
                      }
                    >
                      <Button color="info" className="like">
                        <VisibilityIcon /> VIEW
                      </Button>
                    </Link>
                  )}
                  {(token["travelagent.inventory_control_groups.write"] ===
                    "allowed" ||
                    token.is_admin === "True") && (
                    <Link
                      to={
                        "/admin/MerchantInventoryControlGroup/Delete/" +
                        record.id
                      }
                    >
                      <Button color="danger" className="remove">
                        <DeleteIcon /> DELETE
                      </Button>
                    </Link>
                  )}
                </div>
              )
            };
          })
        );
        setPages(Math.ceil(resp.totalRecords / pagination.pageSize));
        setLoading(false);
      });
  }, [filter, pagination]);

  const handleSearchStringChanged = e =>
    setFilter({
      ...filter,
      searchString: e.target.value === "" ? null : e.target.value
    });

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              MERCHANT INVENTORY CONTROL GROUP
            </h4>
          </CardHeader>
          <CardBody>
            {(token["travelagent.inventory_control_groups.write"] ===
              "allowed" ||
              token.is_admin === "True") && (
              <Link to={"/admin/MerchantInventoryControlGroup/Create"}>
                <Button color="rose" type="button" value="Create">
                  Create
                </Button>
              </Link>
            )}

            <GridItem xs={3}>
              <CustomInput
                labelText="Search"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  onChange: handleSearchStringChanged,
                  value: filter.searchString === null ? "" : filter.searchString
                }}
              />
            </GridItem>
            <GridItem>
              <ReactTable
                manual
                pages={pages}
                page={pagination.pageIndex - 1}
                pageSize={pagination.pageSize}
                onPageChange={page =>
                  setPagination({
                    pageIndex: page + 1,
                    pageSize: pagination.pageSize
                  })
                }
                onPageSizeChange={(pageSize, page) => {
                  setPagination({ pageSize: pageSize, pageIndex: page + 1 });
                }}
                loading={loading}
                data={data}
                filterable={false}
                columns={[
                  {
                    id: "id",
                    Header: "ID",
                    accessor: d => d.id
                  },
                  {
                    id: "code",
                    Header: "Code",
                    accessor: d => d.code
                  },
                  {
                    id: "name",
                    Header: "Name",
                    accessor: d => d.name
                  },

                  {
                    Header: "Actions",
                    accessor: "actions",
                    sortable: false,
                    filterable: false
                  }
                ]}
                defaultPageSize={10}
                showPaginationTop
                showPaginationBottom={false}
                className="-striped -highlight"
              />
            </GridItem>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default MerchantInventoryControlGroupList;
